import type { ApiUser, User, UserSubscription } from '@/api/types';

/**
 * Единственный маппер ответа бэкенда в User. Поля доступа приходят только из
 * /me и /auth/google; /login, /register, /verify-code их не возвращают — там
 * они остаются undefined до первого fetchUser (→ useAccess трактует как платный режим).
 */
export function mapUser(raw: ApiUser): User {
  return {
    id: raw.id,
    name: raw.name,
    email: raw.email,
    emailVerified: !!raw.email_verified_at,
    has_subscription: !!raw.has_subscription,
    has_full_access: raw.has_full_access,
    free_mode: raw.free_mode,
    is_admin: !!raw.is_admin,
    is_internal: !!raw.is_internal,
    clarity: raw.clarity ? { project_id: raw.clarity.project_id ?? null } : null,
    welcome_prompt_shown_at: raw.welcome_prompt_shown_at ?? null,
    onboarding_completed_at: raw.onboarding_completed_at,
    quota: raw.quota ?? null,
    subscription: raw.subscription ?? null,
    paddle_subscription: raw.paddle_subscription ?? null,
    has_paddle_customer: !!raw.has_paddle_customer,
  };
}

/**
 * Живая платная строка Paddle (active · past_due · paused) из /me. Фолбэк на
 * `subscription` с paddle_subscription_id — для объекта из localStorage,
 * сохранённого до появления поля `paddle_subscription`. null — платной подписки нет.
 */
export function paidSubscriptionOf(
  user: Pick<ApiUser, 'paddle_subscription' | 'subscription'> | null | undefined,
): UserSubscription | null {
  return (
    user?.paddle_subscription ??
    (user?.subscription?.paddle_subscription_id ? user.subscription : null)
  );
}

/** Инициалы для аватара: «Alex Kim» → «AK». */
export function initialsOf(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0] ?? '')
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
